/**
 * @Author: Zewei
 * @Date:   2018-01-19T11:14:47+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-01-19T19:46:46+08:00
 */
 import React from 'react';
 // import classNames from 'classnames';
 import './index.less';

 export default ({ links, copyright }) => {
   // const clsString = classNames('globalFooter', className);
   return (
     <div className="globalFooter">
       {
         links && (
           <div className="links">
             {links.map(link => (
               <a
                 key={link.key}
                 target={link.blankTarget ? '_blank' : '_self'}
                 href={link.href}
               >
                 {link.title}
               </a>
             ))}
           </div>
         )
       }
       {copyright && <div className="copyright">{copyright}</div>}
     </div>
   );
 };



// WEBPACK FOOTER //
// ./src/components/GlobalFooter/index.js